function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".settings-button-1{fill:#3ca3e8;}.settings-button-2{fill:#292929;}.settings-button-3{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing_w_Project",
  "data-name": "Landing w/ Project"
}, /*#__PURE__*/React.createElement("circle", {
  className: "settings-button-1",
  cx: 13.09,
  cy: 13.09,
  r: 13.09
}), /*#__PURE__*/React.createElement("circle", {
  className: "settings-button-2",
  cx: 13.09,
  cy: 13.09,
  r: 9.1
}), /*#__PURE__*/React.createElement("path", {
  className: "settings-button-3",
  d: "M19.15,14.61,18.08,14a1,1,0,0,1,0-1.8l1.07-.62a1,1,0,0,0,.38-1.41L18.85,9a1,1,0,0,0-1.41-.38l-1.08.62a1,1,0,0,1-1.55-.9V7.08a1,1,0,0,0-1-1H12.41a1,1,0,0,0-1,1V8.32a1,1,0,0,1-1.55.9L8.74,8.6A1,1,0,0,0,7.33,9l-.68,1.18A1,1,0,0,0,7,11.57l1.07.62a1,1,0,0,1,0,1.8L7,14.61A1,1,0,0,0,6.65,16l.68,1.18a1,1,0,0,0,1.41.38L9.82,17a1,1,0,0,1,1.55.9V19.1a1,1,0,0,0,1,1h1.36a1,1,0,0,0,1-1V17.86a1,1,0,0,1,1.55-.9l1.08.62a1,1,0,0,0,1.41-.38L19.53,16A1,1,0,0,0,19.15,14.61Zm-6.06,1.07a2.59,2.59,0,1,1,2.59-2.59A2.59,2.59,0,0,1,13.09,15.68Z"
})));

function SvgSettingsButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.18 26.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsButton);
export default __webpack_public_path__ + "static/media/SettingsButton.56f8414e.svg";
export { ForwardRef as ReactComponent };